import { createStorefrontApiClient } from '@shopify/storefront-api-client';

export const storefront = createStorefrontApiClient({
  storeDomain: window.Shopify.shop,
  apiVersion: '2025-07',
  publicAccessToken: window.storefrontAccessToken.personalisation
});
